/**
 * Reusable hook for managing dialog open/close state.
 */

import { useCallback, useState } from 'react'

export interface UseDialogStateReturn {
  isOpen: boolean
  open: () => void
  close: () => void
  setIsOpen: (isOpen: boolean) => void
}

export const useDialogState = (initialState = false): UseDialogStateReturn => {
  const [isOpen, setIsOpen] = useState(initialState)

  const open = useCallback(() => setIsOpen(true), [])
  const close = useCallback(() => setIsOpen(false), [])
  const setIsOpenHandler = useCallback((value: boolean) => setIsOpen(value), [])

  return {
    isOpen,
    open,
    close,
    setIsOpen: setIsOpenHandler,
  }
}
